<template>
  <div
    v-if="!isVisitor && profile.is_blurred_avatar"
    class="profile-card__image profile-card__image--small profile-card__image--zoom-in profile-card__image--blurred clickable"
    v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=380)' }"
    v-on:click="emitBuy"
  >
    <div class="lefttop__corner"><i class="demo-icon icon-padlock"></i></div>
    <div class="rightbottom__corner" v-if="!isTopChoice"><i class="demo-icon icon-padlock"></i></div>
    <div class="profile-card__bottom profile-card__bottom--top-choice" v-if="isTopChoice && profile.top_choice_slogan">
      {{ profile.top_choice_slogan }}
    </div>
    <div class="profile-card__middle"><i class="demo-icon icon-n-heart"></i></div>
  </div>
  <div
    v-else-if="isVisitor && profile.is_blurred_avatar"
    class="profile-card__image profile-card__image--small profile-card__image--zoom-in profile-card__image--blurred clickable"
    v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=380)' }"
    v-on:click="emitBuy"
  >
    <div class="lefttop__corner">
      <div class="profile-card__card-symbol">
        <p>{{ profile.age }}</p>
        <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
        <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
      </div>
    </div>
    <div class="leftbottom__corner">
      <div class="profile-card__card-data" v-if="!isTopChoice">
        <h6>{{ profile.name }} <span v-if="profile.is_online" class="dot-online members__online"></span></h6>
        <p v-if="profile.address_form !== 'hidden'"> {{ trans.get('pages:members.profile_card.lives_in') }} {{ profile.address_city }}</p>
        <p v-if="profile.address_form !== 'hidden' && profile.location">
          <i class="demo-icon icon-pin"></i>
          {{ parseInt(profile.location.distance) }} km
        </p>
      </div>
    </div>
    <div class="rightbottom__corner">
      <div class="profile-card__card-symbol"><p class="order-1">{{ profile.age }}</p>
        <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
        <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
      </div>
    </div>
    <div class="profile-card__middle"><i class="demo-icon icon-n-heart"></i></div>
  </div>
  <router-link v-else :to="{name: 'profile', params: { id: profile.id}}" class="unset">
    <div class="profile-card__image profile-card__image--small profile-card__image--zoom-in clickable" v-bind:style="{ 'background-image': 'url(' + profile.avatar_url + '?h=350)' }">

      <div class="profile-card__bottom profile-card__bottom--dark"></div>
      <div class="lefttop__corner">
        <div class="profile-card__card-symbol">
          <p>{{ profile.age }}</p>
          <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
          <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
        </div>
      </div>
      <div class="righttop__corner">
        <div v-if="profile.is_new" class="label-card">{{ trans.get('pages:members.profile_card.new') }}</div>
      </div>
      <div class="leftbottom__corner">
        <div class="profile-card__card-data" v-if="!isTopChoice">
          <h6>{{ profile.name }} <span v-if="profile.is_online" class="dot-online members__online"></span></h6>
          <p v-if="profile.address_form !== 'hidden'"> {{ trans.get('pages:members.profile_card.lives_in') }} {{ profile.address_city }}</p>
          <p v-if="profile.address_form !== 'hidden' && profile.location">
            <i class="demo-icon icon-pin"></i>
            {{ parseInt(profile.location.distance) }} km
          </p>
        </div>
      </div>
      <div class="rightbottom__corner">
        <div class="profile-card__card-symbol"><p class="order-1">{{ profile.age }}</p>
          <div v-if="profile.gender === 'male'" class="male"><i class="demo-icon icon-n-male"></i></div>
          <div v-else class="female"><i class="demo-icon icon-n-female"></i></div>
        </div>
      </div>
      <div class="profile-card__bottom profile-card__bottom--top-choice" v-if="isTopChoice && profile.top_choice_slogan">
        {{ profile.top_choice_slogan }}
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ProfileCard',
  props: {
    profile: Object,
    isTopChoice: Boolean,
    isVisitor: Boolean,
    isOther: Boolean,
  },
  methods: {
    emitBuy: function () {
      this.$emit('buy', { profileId: this.profile.id, isOther: this.isOther, profileAvatar: this.profile.avatar_url });
    }
  }
};
</script>

<style scoped>

</style>
